module.exports = __webpack_public_path__ + "static/acolyte_of_bahamut_mtg_clb-96255c610cf720946c079e1383ee07ef.jpg";